"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchPublicPosts = exports.getPublicPost = exports.getPublicPosts = exports.deletePostRelation = exports.postPostRelation = exports.putPostOrganization = exports.putPostAccessibility = exports.deletePostPermission = exports.postPostPermission = exports.putPostAction = exports.delPost = exports.postPost = exports.putPost = exports.getPost = exports.getPosts = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var postsAuthorizedPath = root_1.cmsAuthorized + '/posts/';
var postsPublicPath = root_1.cmsPublic + '/posts/';

var getPosts = function getPosts(authentication, queryParameters) {
  return common_1.get(authentication, postsAuthorizedPath, queryParameters);
};

exports.getPosts = getPosts;

var getPost = function getPost(authentication, id) {
  return common_1.get(authentication, postsAuthorizedPath + id);
};

exports.getPost = getPost;

var putPost = function putPost(authentication, post) {
  return common_1.put(authentication, postsAuthorizedPath + post.id, post);
};

exports.putPost = putPost;

var postPost = function postPost(authentication, pos) {
  return common_1.post(authentication, postsAuthorizedPath, pos);
};

exports.postPost = postPost;

var delPost = function delPost(authentication, id) {
  return common_1.del(authentication, postsAuthorizedPath + id);
};

exports.delPost = delPost;

var putPostAction = function putPostAction(authentication, id, action, data) {
  return common_1.putSub(authentication, postsAuthorizedPath, id, action, data);
};

exports.putPostAction = putPostAction;

var postPostPermission = function postPostPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, postsAuthorizedPath, id, permission);
};

exports.postPostPermission = postPostPermission;

var deletePostPermission = function deletePostPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, postsAuthorizedPath, id, permissionId);
};

exports.deletePostPermission = deletePostPermission;

var putPostAccessibility = function putPostAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, postsAuthorizedPath, id, accessibility);
};

exports.putPostAccessibility = putPostAccessibility;

var putPostOrganization = function putPostOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, postsAuthorizedPath, id, organizationId);
};

exports.putPostOrganization = putPostOrganization;

var postPostRelation = function postPostRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, postsAuthorizedPath, id, relation);
};

exports.postPostRelation = postPostRelation;

var deletePostRelation = function deletePostRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, postsAuthorizedPath, id, relationId);
};

exports.deletePostRelation = deletePostRelation;

var getPublicPosts = function getPublicPosts(authentication, queryParameters) {
  return common_1.get(authentication, postsPublicPath, queryParameters);
};

exports.getPublicPosts = getPublicPosts;

var getPublicPost = function getPublicPost(authentication, id) {
  return common_1.get(authentication, postsPublicPath + id);
};

exports.getPublicPost = getPublicPost;

var searchPublicPosts = function searchPublicPosts(authentication, queryParameters) {
  return common_1.get(authentication, postsPublicPath + 'search', queryParameters);
};

exports.searchPublicPosts = searchPublicPosts;